export default __webpack_public_path__ + "static/media/leh5.8150edec.jpg";